export default "__VITE_ASSET__DnxuJsyy__"